import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Stones.module.css";

const localStones = [
  { 
    name: "Royal Granite", 
    image: "/TOWER.jpg",
    description: "Distinguished natural stone with exquisite crystalline patterns and remarkable durability",
    origin: "Finest local quarries",
    
  },
  { 
    name: "Heritage Sandstone", 
    image: "/TOWER.jpg",
    description: "Elegant sedimentary formation with rich, warm tones that evoke the grandeur of historic estates",
    origin: "Provincial reserves",
   
  },
  { 
    name: "Imperial Basalt", 
    image: "/TOWER.jpg",
    description: "Noble volcanic stone renowned for its formidable strength and majestic dark appearance",
    origin: "Protected volcanic regions",
   
  },
  { 
    name: "Victorian Slate", 
    image: "/TOWER.jpg",
    description: "Distinguished metamorphic stone that graces the finest properties with timeless elegance",
    origin: "Historic mountain provinces",
    
  },
  { 
    name: "Victorian Slate", 
    image: "/TOWER.jpg",
    description: "Distinguished metamorphic stone that graces the finest properties with timeless elegance",
    origin: "Historic mountain provinces",
    
  }

];

const importedStones = [
  { 
    name: "Carrara Marble", 
    image: "/TOWER.jpg",
    description: "Prestigious Italian stone with magnificent veining, favored by royalty for generations",
    origin: "Tuscany, Italy",
   
  },
  { 
    name: "Noble Limestone", 
    image: "/TOWER.jpg",
    description: "Regal sedimentary stone that has adorned palaces and cathedrals throughout history",
    origin: "Loire Valley, France",
    
  },
  { 
    name: "Sovereign Travertine", 
    image: "/TOWER.jpg",
    description: "Distinctive natural formation with characteristic texture and incomparable old-world charm",
    origin: "Anatolia, Ottoman Empire",
    
  },
  { 
    name: "Palatial Onyx", 
    image: "/TOWER.jpg",
    description: "Translucent gem-like stone reserved for the most distinguished interiors and accents",
    origin: "Mexican Highlands",
    
  }
];

const StoneCard = ({ stone, index }) => {
  return (
    <div 
      className={styles.stoneCard} 
      style={{ '--index': index }}
    >
      <img src={stone.image} alt={stone.name} />
      <h4>{stone.name}</h4>
      {stone.description && <p className={styles.stoneDescription}>{stone.description}</p>}
      {stone.origin && <span className={styles.stoneOrigin}>{stone.origin}</span>}
      {stone.established && <div className={styles.established}>{stone.established}</div>}
    </div>
  );
};

const StonesList = ({ stones }) => (
  <div className={styles.stonesList}>
    {stones.map((stone, idx) => (
      <StoneCard key={idx} stone={stone} index={idx} />
    ))}
  </div>
);

const Stones = ({ type }) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Add a slight delay for animation effect
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 200);
    
    return () => clearTimeout(timer);
  }, [type]);
  
  // Render the appropriate stones list based on the type prop
  const renderStoneContent = () => {
    if (type === "local") {
      return (
        <div className={`${styles.stoneContent} ${isVisible ? styles.visible : ''}`}>
          <h2>Distinguished Provincial Stones</h2>
          <p className={styles.stoneIntro}>
            Meticulously curated from our region's most esteemed quarries, these remarkable stones 
            embody the noble character of our land. Each specimen is selected to uphold 
            the distinguished reputation we have maintained since the Victorian era.
          </p>
          <StonesList stones={localStones} />
          <div className={styles.backLink}>
            <button 
              onClick={() => navigate("/?page=/stones")} 
              className={styles.backButton}
            >
              Return to Collection
            </button>
          </div>
        </div>
      );
    } else if (type === "imported") {
      return (
        <div className={`${styles.stoneContent} ${isVisible ? styles.visible : ''}`}>
          <h2>Sovereign Foreign Stones</h2>
          <p className={styles.stoneIntro}>
            Procured from the world's most prestigious quarries by our master stone merchants, 
            these exceptional imported treasures bring international distinction and nobility
            to the most discerning architectural endeavors.
          </p>
          <StonesList stones={importedStones} />
          <div className={styles.backLink}>
            <button 
              onClick={() => navigate("/?page=/stones")} 
              className={styles.backButton}
            >
              Return to Collection
            </button>
          </div>
        </div>
      );
    } else {
      // Default view - selector buttons
      return (
        <div className={styles.selector}>
          <h2>Distinguished Stone Collection</h2>
          <p className={styles.selectorIntro}>
            For generations, Throne Stone has provided the finest quality materials to those who appreciate
            the timeless elegance of natural stone. Our master craftsmen select only the most exceptional
            specimens, whether from our historic provincial quarries or imported from noble foreign lands.
          </p>
          <div className={styles.buttonContainer}>
            <button 
              className={styles.selectorButton} 
              onClick={() => navigate("/?page=/stones/local")}
            >
              Provincial Stones
            </button>
            <button 
              className={styles.selectorButton} 
              onClick={() => navigate("/?page=/stones/imported")}
            >
              Foreign Stones
            </button>
          </div>
        </div>
      );
    }
  };

  return (
    <div className={styles.stonesPage}>
      <h1>Stone Collection</h1>
      {renderStoneContent()}
    </div>
  );
};

export default Stones;